import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { RoutesPaths } from "../Router/constant";
import { toast } from "react-toastify";
import { verifyPartnerEmail, resetPartnerPassword } from "../Services/authService";

export default function ResetPassword() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [verifiedEmail, setVerifiedEmail] = useState("");
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleVerifyEmail = async () => {
        setError("");
        if (!email) return setError("Please enter email.");

        setLoading(true);
        try {
            const res = await verifyPartnerEmail({ email });
            if (res.data.status === true) {
                setVerifiedEmail(res.data.data.email);
                toast.success(res.data.data.message);
            } else {
                setError(res.data.data.message || "Email verification failed");
            }
        } catch (err) {
            setError(err.data?.data?.message || "Email verification failed");
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = async () => {
        setError("");
        if (!oldPassword || !newPassword || !confirmPassword) {
            return setError("Please fill all password fields.");
        }

        setLoading(true);
        try {
            const res = await resetPartnerPassword({
                email: verifiedEmail,
                oldPassword,
                newPassword,
                confirmPassword,
            });
            if (res.data.status === true) {
                toast.success(res.data.data.message);
                navigate(RoutesPaths.SIGNIN);
            } else {
                setError(res.data.data.message || "Password reset failed");
            }
        } catch (err) {
            setError(err?.response?.data?.data?.message || "Password reset failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-4 authAlignmentSection authLeftSectionPartner">
                    <img src="/assets/img/quimeraLogo.svg" alt="Quimera Logo" className="quimeraLogo" />
                    <div className="authLeftSectionDetails">
                        <h3 className="m-0 partnerText">Vendor Portal</h3>
                        <p className="m-0 partnerText">Manage bookings, contracts, and services with ease.</p>
                    </div>
                    <img src="/assets/img/partnerLogo.png" alt="Vendor Dashboard" className="img-fluid" />
                </div>

                <div className="col-md-8 authFormSection">
                    <div>
                        <img src="/assets/img/quimeraLogo.svg" alt="" className="mobileView" />
                    </div>
                    <div className="outerFormInnerDetails">
                        <div className="formInnerDetailsReset">
                            <img src="/assets/img/keyIcon.svg" alt=" " className="keyIconImg" />
                            <h6 className="m-0 text-center">Reset Password</h6>
                            <p className="m-0 text-center">
                                {verifiedEmail
                                    ? "Enter your old password and choose a new password."
                                    : "Enter your email to verify your account."}
                            </p>

                            {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}

                            {/* Step 1: Email input */}
                            {!verifiedEmail && (
                                <div className="inputFieldSection">
                                    <p className="m-0">Email</p>
                                    <input
                                        type="email"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                            )}

                            {/* Step 2: Password fields */}
                            {verifiedEmail && (
                                <>
                                    <div className="inputFieldSection">
                                        <p className="m-0">Old Password</p>
                                        <div className="password-wrapper">
                                            <input
                                                type={showOldPassword ? "text" : "password"}
                                                placeholder="Enter your old password"
                                                value={oldPassword}
                                                onChange={(e) => setOldPassword(e.target.value)}
                                            />
                                            <img
                                                src={
                                                    showOldPassword
                                                        ? "/assets/img/eye-off.svg"
                                                        : "/assets/img/eye.svg"
                                                }
                                                alt="toggle password"
                                                className="eye-icon"
                                                onClick={() => setShowOldPassword(!showOldPassword)}
                                            />
                                        </div>
                                    </div>

                                    <div className="inputFieldSection">
                                        <p className="m-0">New Password</p>
                                        <div className="password-wrapper">
                                            <input
                                                type={showNewPassword ? "text" : "password"}
                                                placeholder="Enter your new password"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                            />
                                            <img
                                                src={
                                                    showNewPassword
                                                        ? "/assets/img/eye-off.svg"
                                                        : "/assets/img/eye.svg"
                                                }
                                                alt="toggle password"
                                                className="eye-icon"
                                                onClick={() => setShowNewPassword(!showNewPassword)}
                                            />
                                        </div>
                                    </div>

                                    <div className="inputFieldSection">
                                        <p className="m-0">Confirm Password</p>
                                        <div className="password-wrapper">
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                placeholder="Confirm your password"
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            <img
                                                src={
                                                    showConfirmPassword
                                                        ? "/assets/img/eye-off.svg"
                                                        : "/assets/img/eye.svg"
                                                }
                                                alt="toggle password"
                                                className="eye-icon"
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            />
                                        </div>
                                    </div>

                                </>
                            )}

                            <button
                                type="button"
                                className="signInButtonPartner buttonFullWidth"
                                onClick={verifiedEmail ? handleResetPassword : handleVerifyEmail}
                                disabled={loading}
                            >
                                {loading ? "Processing..." : verifiedEmail ? "Reset" : "Verify Email"}
                            </button>

                            <NavLink to={RoutesPaths.SIGNIN} style={{ textDecoration: "none" }}>
                                <p className="m-0 backToLogin">
                                    <img src="/assets/img/arrow-left.svg" alt="" /> Back to log in
                                </p>
                            </NavLink>
                        </div>
                    </div>
                    <div className="yearText">
                        <p className="m-0">© Quimera {new Date().getFullYear()}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
